(function () {
  function bindCarousel(root) {
    var el = root.querySelector(".v3-gdu-swiper");
    if (!el) return;
    if (typeof Swiper === "undefined") {
      var tries = Number(el.getAttribute("data-gdu-swiper-tries") || 0);
      if (tries > 40) return;
      el.setAttribute("data-gdu-swiper-tries", String(tries + 1));
      setTimeout(function () {
        bindCarousel(root);
      }, 50);
      return;
    }
    if (el.swiper) el.swiper.destroy(true, true);

    new Swiper(el, {
      slidesPerView: 1.08,
      spaceBetween: 8,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      watchOverflow: false,
      navigation: {
        nextEl: el.querySelector(".v3-gdu__arrow--next"),
        prevEl: el.querySelector(".v3-gdu__arrow--prev")
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 12,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });
  }

  function isPifyMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function applyPifyScroll(modal) {
    if (!modal || !modal.hasAttribute("data-gdu-pify")) return;
    modal.querySelectorAll("iframe").forEach(function (iframe) {
      if (isPifyMobile()) {
        iframe.style.overflow = "auto";
        iframe.removeAttribute("scrolling");
        return;
      }
      iframe.style.overflow = "hidden";
      iframe.setAttribute("scrolling", "no");
    });
  }

  function bindPifyHeight(root) {
    if (root.getAttribute("data-gdu-pify-msg") === "1") return;
    root.setAttribute("data-gdu-pify-msg", "1");
    window.addEventListener("message", function (event) {
      if (!event || typeof event.data !== "string") return;
      var payload;
      try {
        payload = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (!payload || payload.height == null || isPifyMobile()) return;
      var height = Number(payload.height);
      if (!height) return;
      root.querySelectorAll("[data-gdu-pify] .pifyform").forEach(function (form) {
        if (payload.formId != null && form.id !== "pifyform-" + payload.formId) {
          return;
        }
        form.style.height = height + "px";
      });
    });
  }

  function bindModal(root, modalSel, openSel, closeSel) {
    var modal = root.querySelector(modalSel);
    if (!modal) return;
    var openers = root.querySelectorAll(openSel);
    var closers = root.querySelectorAll(closeSel);

    function open() {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      applyPifyScroll(modal);
    }

    function close() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    openers.forEach(function (el) {
      el.addEventListener("click", function (event) {
        event.preventDefault();
        open();
      });
    });
    closers.forEach(function (el) {
      el.addEventListener("click", close);
    });
    modal.addEventListener("click", function (event) {
      if (event.target === modal) close();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) close();
    });
  }

  function initRoot(root) {
    if (!root) return;
    bindCarousel(root);
    if (root.getAttribute("data-gdu-bound") === "1") return;
    root.setAttribute("data-gdu-bound", "1");
    bindModal(root, "[data-gdu-rules]", "[data-gdu-open-rules]", "[data-gdu-close-rules]");
    bindModal(root, "[data-gdu-pify]", "[data-gdu-open-pify]", "[data-gdu-close-pify]");
    bindPifyHeight(root);
  }

  document.querySelectorAll("[data-gdu-root]").forEach(initRoot);
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-gdu-root]");
    if (!root) return;
    root.removeAttribute("data-gdu-bound");
    initRoot(root);
  });
})();
